export default __webpack_public_path__ + "static/Explorations-1c6c219ac47e343bb2a0ecb935c62659.png";